









import Vue, { PropType } from 'vue'

type CustomIconName =
  | 'app'
  | 'profile'
  | 'credit-card'
  | 'truck-delivery'
  | 'user-address'
  | 'partner-address'
  | 'store'
  | 'store-owner'
  | 'bank'

const icons: { [key in CustomIconName]: string } = {
  app: 'ic_app.png',
  profile: 'ic_profile.svg',
  'credit-card': 'ic_credit-card.svg',
  'truck-delivery': 'ic_truck-delivery.svg',
  'user-address': 'ic_user-address.svg',
  'partner-address': 'ic_partner-address.svg',
  store: 'ic_store.svg',
  'store-owner': 'ic_store-owner.svg',
  bank: 'ic_bank.svg',
}

export default Vue.extend({
  name: 'CustomIcon',
  props: {
    name: {
      type: String as PropType<CustomIconName>,
      required: true,
    },
  },
  computed: {
    src(): string {
      return icons[this.name]
    },
  },
})
